import React from "react";
import CreateMerchandiser from "./CreateMerchandiser";

const Merchandiser = (props) => {
    const {selectedBuyingOffice} = props;
    return <CreateMerchandiser  selectedBuyingOffice={selectedBuyingOffice}/>

}

export default Merchandiser;